'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dNo$002dSpinner$0024 from "./presto.-No-Spinner$.js";
var $p;
function $p_Lpresto_Fetcher$CombinedRequestBuilder__merge$1__s_util_Try__s_util_Try__s_util_Try($thiz, triedA, triedB) {
  var x25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(triedA, triedB);
  var x44 = x25.jB;
  var x45 = x25.jC;
  if ((x44 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
    var a = x44.T;
    if ((x45 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(a, x45.T));
    }
    if ((x45 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(x45.ak);
    }
  }
  if ((x44 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
    var x37 = x44.ak;
    if ((x45 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Success)) {
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(x37);
    }
    if ((x45 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
      var b$3 = x45.ak;
      return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_Exception__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_Exception(), (((("Both have failed (a: " + x37.aM()) + ", b: ") + b$3.aM()) + ")")));
    }
  }
  throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_MatchError(x25);
}
export { $p_Lpresto_Fetcher$CombinedRequestBuilder__merge$1__s_util_Try__s_util_Try__s_util_Try as $p_Lpresto_Fetcher$CombinedRequestBuilder__merge$1__s_util_Try__s_util_Try__s_util_Try };
/** @constructor */
function $c_Lpresto_Fetcher$CombinedRequestBuilder(a, b, decA, decB, log, spinner) {
  this.mS = null;
  this.mT = null;
  this.mU = null;
  this.mV = null;
  this.om = null;
  this.Xe = null;
  this.mS = a;
  this.mT = b;
  this.mU = decA;
  this.mV = decB;
  this.om = log;
  this.Xe = spinner;
}
export { $c_Lpresto_Fetcher$CombinedRequestBuilder as $c_Lpresto_Fetcher$CombinedRequestBuilder };
$p = $c_Lpresto_Fetcher$CombinedRequestBuilder.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_Fetcher$CombinedRequestBuilder;
/** @constructor */
function $h_Lpresto_Fetcher$CombinedRequestBuilder() {
}
export { $h_Lpresto_Fetcher$CombinedRequestBuilder as $h_Lpresto_Fetcher$CombinedRequestBuilder };
$h_Lpresto_Fetcher$CombinedRequestBuilder.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_Fetcher$CombinedRequestBuilder)) {
    var x = this.mS;
    var x$2 = x$0.mS;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.mT;
      var x$4 = x$0.mT;
      var $x_4 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$5 = this.mU;
      var x$6 = x$0.mU;
      var $x_3 = (x$5 === x$6);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$7 = this.mV;
      var x$8 = x$0.mV;
      var $x_2 = (x$7 === x$8);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$9 = this.om;
      var x$10 = x$0.om;
      var $x_1 = ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$11 = this.Xe;
      var x$12 = x$0.Xe;
      return ((x$11 === null) ? (x$12 === null) : x$11.i(x$12));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 6;
});
$p.s = (function() {
  return "CombinedRequestBuilder";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.mS;
      break;
    }
    case 1: {
      return this.mT;
      break;
    }
    case 2: {
      return this.mU;
      break;
    }
    case 3: {
      return this.mV;
      break;
    }
    case 4: {
      return this.om;
      break;
    }
    case 5: {
      return this.Xe;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
$p.aO = (function() {
  return new $c_Lpresto_Fetcher$CombinedRequestBuilder(this.mS, this.mT, this.mU, this.mV, this.om, $j_presto$002e$002dNo$002dSpinner$0024.$m_Lpresto_NoSpinner$());
});
$p.an = (function(handler, decoder) {
  var this$3 = this.mS.aO().an(handler, this.mU);
  var project$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((resultA) => new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this.mT.aO().an(handler, this.mV), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((resultA$2) => ((resultB) => $p_Lpresto_Fetcher$CombinedRequestBuilder__merge$1__s_util_Try__s_util_Try__s_util_Try(this, resultA$2, resultB)))(resultA)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$())));
  var strategy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_core_Observable$().bc;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_airstream_flatten_FlattenStrategy$().czx();
  return strategy.aZ(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapStream(this$3, project$1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
});
function $isArrayOf_Lpresto_Fetcher$CombinedRequestBuilder(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ic)));
}
export { $isArrayOf_Lpresto_Fetcher$CombinedRequestBuilder as $isArrayOf_Lpresto_Fetcher$CombinedRequestBuilder };
var $d_Lpresto_Fetcher$CombinedRequestBuilder = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$CombinedRequestBuilder, "presto.Fetcher$CombinedRequestBuilder", ({
  ic: 1,
  ie: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_Fetcher$CombinedRequestBuilder as $d_Lpresto_Fetcher$CombinedRequestBuilder };
//# sourceMappingURL=presto.-Fetcher$-Combined-Request-Builder.js.map
